import { render } from "./Form.vue?vue&type=template&id=f58401b6&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=f58401b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f58401b6"

export default script